<template>
  <div>
    <iframe
      class="layout"
      src="http://wx7efc043d7b6119c9.web.rushifckj.com/act/online/tcygc-bird-2021-06/embed/index.html?v=1"
    ></iframe>
    <div class="tips-box">
      <div class="count">
        <div>
          当前剩余次数
          <span>{{count}}</span>
        </div>
      </div>
      <div class="tips" v-show="!tipsStatus">不断点击屏幕控制锦鲤跳跃<br />穿过管道达到10分即可参加抽奖</div>
    </div>
    <div class="center-tips" v-show="tipsStatus">不断点击屏幕控制锦鲤跳跃<br />穿过管道达到10分即可参加抽奖</div>
    <div class="mask" @click="noGameCount" v-if="count === 0  && !isBegin"></div>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  data() {
    return {
      score: -1,
      count: 0,
      loopGameloop: "",
      loopPipeloop: "",
      info: {},
      isBegin: false,
      isGameCheck: false,
      tipsStatus: true
    };
  },
  computed: {},
  methods: {
    async getGameCount() {
      const data = await this.$httpdf.get(this.apiHost + 'bird/gameCount')
      console.log("游戏次数", data.data);
      this.count = data.data.gameCount;
    },
    async getGameInfo() {
      const data = await this.$httpdf.get(this.apiHost + 'bird/info')
      this.info = data.data;
    },
    async drawGame() {
      const data = await this.$httpdf.get(this.apiHost + 'bird/drawGame', {count: this.score})
      if (data.data === 1 ) {
        this.$modal.birdSuccess.alert().then(res => {
          if (res == "ok") {
            this.$goPage("dzp");
          }
        })
      } else if (data.data === 0){
        let message = {
          val: this.score,
          count: this.count
        }
        this.$modal.birdContinue.alert(message).then(res => {
          if (res == "ranking") {
            this.$goPage("birdRanking");
          } else if (res == "gameagain") {
            if (this.count <= 0) {
              this.noGameCount()
            }
          }
        });
      }
      this.isBegin = false
      this.isGameCheck = false
    },
    gameCheck() {
      if (this.isGameCheck) {
        return
      }
      if (this.score >= 0) {
        this.isGameCheck = true
        //达到抽奖条件
        clearInterval(this.loopGameloop);
        clearInterval(this.loopPipeloop);
        this.drawGame()
      } 
    },
    noGameCount() {
      if (this.isBegin) {
        return
      }
      this.$modal.birdFail.alert().then(res => {
        if (res == "ranking") {
          this.$goPage("birdRanking");
        } else if (res == "onSave") {
          let text = {
            text1: "因为",
            text2: "分享",
            text3: "，所以世界有了光！",
            text4: "好东西必须让更多朋友知道"
          };
          this.$modal.share.alert(text).then(res => {
            if (res == "onSave") {
              this.$goPage("poster");
            }
          });
        }
      });
    },
    wsfunc(e) {
      if (e.data.type === "success") {
        this.score = e.data.score;
        this.loopGameloop = e.data.loopGameloop;
        this.loopPipeloop = e.data.loopPipeloop;
        console.log(e.data);
      }
      if (e.data.ifstart === "true" && e.data.score === undefined) {
        if (this.count > 0) {
          this.beginGame();
        } else {
          this.noGameCount()
        }
      } else {
        this.gameCheck()
      }
    },
    async beginGame() {
      if (this.isBegin) {
        return
      }
      setTimeout(()=> {
        this.tipsStatus = false
      }, 3500)
      await this.$httpdf.get(this.apiHost + 'bird/beginGame')
      this.count--
      this.isBegin = true
    }
  },
  mounted() {
    // 这里监听游戏子iframe传递过来的信息
    // window.addEventListener("message", e => {
    //   // console.log(e.data)
    //   if (e.data.type === "success") {
    //     this.score = e.data.score;
    //     this.loopGameloop = e.data.loopGameloop;
    //     this.loopPipeloop = e.data.loopPipeloop;
    //     console.log(e.data);
    //   }
    // });
    this.getGameCount();
    this.getGameInfo()
    window.addEventListener("message", this.wsfunc, true);
    this.$wx.shareCallBackFunList.push("share1", async () => {
      await this.$httpdf.post(this.apiHost + 'share/share');
      this.getGameCount();
      this.$modal.share.close()
      this.$modal.birdFail.close()
    });
  },
  destroyed() {
    clearInterval(this.loopGameloop);
    clearInterval(this.loopPipeloop);
    this.loopGameloop = null;
    this.loopPipeloop = null;
    window.removeEventListener("message", this.wsfunc, true);
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.layout {
  border: 0;
  outline-width: 0;
}
.footer {
  position: fixed;
  bottom: 52px;
  right: 18px;
  width: 47px;
  height: 47px;
  background: linear-gradient(
    -34deg,
    rgba(202, 37, 171, 1),
    rgba(255, 55, 120, 1)
  );
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
}

.fh {
  padding: 5px 6px;
}
.tips-box {
  position: fixed;
  top: 20px;
  left: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .count {
    width: 110px;
    height: 28px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.5;
    border-radius: 14px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    line-height: 28px;
    font-weight: bold;
  }
  .tips {
    color: #fff;
    font-size: 15px;
    text-align: center;
    font-weight: bold;
    line-height: 150%;
  }
}
.center-tips {
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  color: #fff;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
  line-height: 150%;
}
.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

</style>
